module.exports = __webpack_public_path__ + "img/CK.04a4c8d0.svg";